export default __webpack_public_path__ + "img/13e0362e91bb3bb867bc5ff50281ac43.png";